module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "nonindent11"
  }, [_c('a', {
    attrs: {
      "id": "pagei"
    }
  }), _c('a', {
    attrs: {
      "id": "pageii"
    }
  }), _vm._v("Critic, essayist, reporter, novelist, memoirist, travel writer, translator, poet, playwright, controversialist, E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("DMUND")]), _vm._v(" W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ILSON")]), _vm._v(" (1895–1972) was one of this country’s and this century’s greatest literary figures. He was an intimate of many of the leading figures of the Lost Generation, most notably his Princeton schoolmate F. Scott Fitzgerald, whose posthumous works "), _c('i', [_vm._v("The Crack-up")]), _vm._v(" and "), _c('i', [_vm._v("The Last Tycoon")]), _vm._v(" he edited. Among the greatest of his many books were "), _c('i', [_vm._v("To the Finland Station, Axel’s Castle, Apologies to the Iroquois, Upstate, The Wound and the Bow, Memoirs of Hecate County")]), _vm._v(", and his chronicles of the literary decades "), _c('i', [_vm._v("The Shores of Light, Classics and Commercials,")]), _vm._v(" and "), _c('i', [_vm._v("The Bit Between My Teeth.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-493fb0e8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/fm1.vue
// module id = 57
// module chunks = 0